iScreenWizard.factory('Ontwikkelwijzer', function ($q, Ajax) {

    var data = {};


    data.downloadReport = function(ontwikkelwijzer) {
        var competentie_ids = [];
        var ontwikkelwijzerblok_ids = [];

        angular.forEach(ontwikkelwijzer.competenties, function(competentie) {
            competentie_ids.push(competentie.id);
        });
        angular.forEach(ontwikkelwijzer.ontwikkelwijzerblokken, function(ontwikkelwijzerblok) {
            ontwikkelwijzerblok_ids.push(ontwikkelwijzerblok.id);
        });

        params = {
            _method: 'genereer_rapport',
            opleidingsniveau_id: ontwikkelwijzer.opleidingsniveau.id,
            competentie_ids: competentie_ids,
            ontwikkelwijzerblok_ids: ontwikkelwijzerblok_ids,
        };

        return $q(function (resolve, reject) {
            Ajax.post('ontwikkelwijzer', params).then(function (response) {
                resolve(response);
            }, reject);
        });
    };

    return data;
});